module.exports = __webpack_public_path__ + "img/hammer.38339e0a.svg";